import React from "react";
import NameMasterPage from "./NameMasterPage";

export default function ProcessMaster() {
  return (
    <NameMasterPage
      title="Process Master"
      subtitle="Processes shown when Purchase Group = Labour Work."
      apiBase="/processes"
      templateName="process_template.xlsx"
      testidPrefix="process"
    />
  );
}
